module.exports = __webpack_public_path__ + "static/media/404-lock.24176e23.svg";